module.exports = __webpack_public_path__ + "static/media/xby.3634f1a4.svg";